import { Dispatch } from 'redux';
import GoHighLevelController from '../controllers/GoHighLevelController';
import commonHandler from '../errorHandlers/common-handler';
import { OauthUrlResponse } from '../model/GoHighLevelModel';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import CrudActionContainer from './CrudActionContainer';

class GoHighLevelCRUDActions extends CrudActionContainer {
  retrieveOauthUrlAction: string;
  retrieveLocations: string;
  retrieveAccounts: string;
  revokeAction: string;
  resetStore: string;

  constructor() {
    super('GoHighLevel');
    this.retrieveOauthUrlAction = this.makeActionKey('RETRIEVED_OAUTH_URL');
    this.retrieveLocations = this.makeActionKey('RETRIEVED_LOCATIONS');
    this.retrieveAccounts = this.makeActionKey('RETRIEVED_ACCOUNTS');
    this.revokeAction = this.makeActionKey('REVOKE');
    this.resetStore = this.makeActionKey('RESET_STORE');
  }

  getGoHighLevelOauthUrl(tokenId?: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveOauthUrlAction));
      try {
        const response: OauthUrlResponse =
          await GoHighLevelController.getOauthUrl(tokenId);
        dispatch({
          type: this.retrieveOauthUrlAction,
        });

        return response.link;
      } catch (error) {
        commonHandler(dispatch)(error);
      } finally {
        this.unbusy();
      }
    };
  }

  getAccounts(facebookPageId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAccounts));
      try {
        const response = await GoHighLevelController.getAccounts(
          facebookPageId,
        );
        dispatch({
          type: this.retrieveAccounts,
          accounts: response,
        });
        return response;
      } catch (error) {
        return commonHandler(dispatch)(error);
      } finally {
        dispatch(this.unbusy());
      }
    };
  }

  getLocations(facebookPageId: number, tokenId: number, force: boolean) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAccounts));
      try {
        const response = await GoHighLevelController.getLocations(
          facebookPageId,
          tokenId,
          force,
        );
        dispatch({
          type: this.retrieveLocations,
          locations: response,
        });
        return response;
      } catch (error) {
        return commonHandler(dispatch)(error);
      } finally {
        dispatch(this.unbusy());
      }
    };
  }

  revokeAccess(accountId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.revokeAction));

      try {
        const response = await GoHighLevelController.revokeAccess(accountId);
        dispatch({
          type: this.revokeAction,
          id: response.success ? accountId : null,
        });
        return response.success;
      } catch (error) {
        commonHandler(dispatch)(error);
        return false;
      }
    };
  }

  invalidateStore() {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch({ type: this.resetStore });
    };
  }
}

const goHighLevelCRUDActions = new GoHighLevelCRUDActions();

export default goHighLevelCRUDActions;

export const useGoHighLevelCRUDActions = getActionHookBuilder(
  goHighLevelCRUDActions,
  [
    'getGoHighLevelOauthUrl',
    'getAccounts',
    'revokeAccess',
    'invalidateStore',
    'getLocations',
  ],
);
